import { render } from "./Sad.vue?vue&type=template&id=781f7992&scoped=true"
import script from "./Sad.vue?vue&type=script&lang=js"
export * from "./Sad.vue?vue&type=script&lang=js"

import "./Sad.vue?vue&type=style&index=0&id=781f7992&lang=scss&scoped=true"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/certificate-site-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-781f7992"]])

export default __exports__